import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { TextField, TableFooter, TablePagination } from '@material-ui/core';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Client from '../common/clients';
import { Button } from '@material-ui/core';



const styles = theme => ({
  item : {
    marginBottom: '20px',
  },
  header: {
    height: '50px',
    textAlign: 'center',
    paddingTop: '20px'
  },
});


class PatientList extends Component {

  constructor(props) {
    super(props);
    this.client = new Client();

    this.state = {
      allPatients: [],
      page: 0,
      search: ''
    }
  }

  componentWillMount() {
    this.client.getPatients().then((data) => {
      this.setState({
        allPatients: data
      });
    });
  }

  setCurrentPage(newPage) {
      this.setState({
        page: newPage
      }
    )
  }

  removePatient(id) {
    const {allPatients} = this.state; 

    this.setState(
      {
        allPatients: allPatients.filter((item) => item.id !== id)
      }
    )
  }

  render() {
    const { classes } = this.props;
    const { allPatients, page, search } = this.state;

    const term = search.trim().toLowerCase();
    const patients = term
      ? allPatients.filter((patient) => `${patient.name} ${patient.lastname}`.toLowerCase().includes(term))
      : allPatients.slice(page * 9, page * 9 + 9);

    return (
      <Grid container justify="center">
          <Grid className={classes.item} item xs={12}>
            <Paper className={classes.header}>
              <div className={classes.text}  variant="h4">
                  Patients
              </div>
            </Paper>
          </Grid>
          <Grid item xs={1}   className={classes.action}>
            <Button color="primary" variant="contained" component={Link} to="/patients/create">
              Ajouter
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Grid container style={{alignItems: 'center', justifyContent: 'center', marginBottom: '30px'}}>
              <Grid item xs={9}>
                <TextField
                  id="outlined-name"
                  label="Rechercher"
                  className={classes.textField}
                  value={search}
                  onChange={(e) => {
                    this.setState({
                      search: e.target.value,
                      page: 0
                    });
                  }}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
          <Paper>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell align="center">Nom</TableCell>
                    <TableCell align="center">Ville</TableCell>
                    <TableCell align="center">Catégorie</TableCell>
                    <TableCell align="right">Editer</TableCell>
                    <TableCell align="right">Archiver</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {patients.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index+1}
                      </TableCell>
                      <TableCell align="center">{row.name} {row.lastname}</TableCell>
                      <TableCell align="center">{row.city}</TableCell>
                      <TableCell align="center">{row.category}</TableCell>
                      <TableCell align="right"><Link className={classes.link} to={`/patients/${row.id}`} ><EditIcon/></Link></TableCell>
                      <TableCell align="right" onClick={async () => { if(window.confirm('Etes vous sur de supprimer ce patient ?')){
                          const res = await this.client.archivedPatient(row.id);
                          if (res) {
                              this.removePatient(row.id);
                          }
                       } }}><DeleteIcon/></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                {term === '' && <TableFooter>
                    <TableRow>
                      <TablePagination
                      rowsPerPageOptions={[9]}
                      colSpan={patients.length}
                      labelDisplayedRows={({ from, to, count }) => `Page ${from}-${count}`}
                      page={page}
                      count={Math.ceil(allPatients.length/9)}
                      rowsPerPage={1}
                      onChangePage={(event, newPage) => {
                        this.setCurrentPage(newPage)
                      }}
                      />
                    </TableRow>
                  </TableFooter>
                }
              </Table>            
            </Paper>
          </Grid>
      </Grid>
    )
  }
}


PatientList.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(PatientList);
